<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Propostas >> {{formtitle}}</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <proposta-fields :proposta="proposta" />

        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{buttom}}</button>
        </div>
      </form>
    </article>
    <div class="buttons-adicional">
      <b-button
        class="button novagrade"
        @click="$router.push({ name: 'admin/grade/create', params: { }})"
      >
        <p>ADICIONAR NOVA GRADE</p>
      </b-button>
      <b-button class="button addvideoaula" @click="addRow()">
        <p>ADICIONAR VIDEOAULA</p>
      </b-button>
    </div>
  </div>
</template>
<script>
import PropostaFields from "@/components/Forms/PropostaFields";

export default {
  name: "propostaForm",
  props: ["proposta", "buttom", "formtitle"],
  created(){
    this.addRow()
  },
  methods: {
    addRow: function() {
      this.proposta.videos.push({
        ordem: "",
        titulo: "",
        descricao: "",
        video: {
          name: "Escolha um video"
        },
        video_url: null, //quando o video termina de carregar deve ser guardado a url de retorno nessa variavel
        progress: null
      });
    },
    validate() {
      let err = false;
      this.proposta.videos.forEach(el => {
        if (el.video_url === "" || el.video_url === null) {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Existe algum video em upload ou sem arquivo, por favor aguarde ou remova-o",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          err = true;
        }
      });
      if (err) return;
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.proposta, () => {});
        }
      });
    }
  },
  components: {
    PropostaFields: PropostaFields
  },
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  }
};
</script>
